import React from 'react';

import { Typography, Box, useTheme } from '@material-ui/core';

import { getExpiringDays, formatDate, isDateExpiring, isDateExpired } from '@vyce/core/src/utils';

const DOES_NOT_HAVE_QUALIFICATION_STATUS = 'Does not have qualification';

type Props = {
  verified: boolean;
  expiry_date?: string | null;
  status?: string;
};

export const TextStatusComponent = ({ verified, expiry_date, status }: Props) => {
  const theme = useTheme();
  if (status === DOES_NOT_HAVE_QUALIFICATION_STATUS) {
    return (
      <Box color={theme.palette.text.secondary} key="status_component">
        <Typography variant="subtitle2">Does not have qualification</Typography>
      </Box>
    );
  }
  if (verified && expiry_date === null) {
    return (
      <Box color={theme.palette.primary.main} key="status_component">
        <Typography variant="subtitle2">Valid</Typography>
      </Box>
    );
  }
  if (verified && isDateExpiring(expiry_date)) {
    const days = getExpiringDays(formatDate(expiry_date ?? null, undefined, 'DD/MM/YYYY'));
    return (
      <Box color={theme.palette.warning.main} key="status_component">
        <Typography variant="subtitle2">Expiring {days ? `(${days} days)` : ''}</Typography>
      </Box>
    );
  }
  if (verified && isDateExpired(expiry_date)) {
    return (
      <Box color={theme.palette.error.main} key="status_component">
        <Typography variant="subtitle2">Expired</Typography>
      </Box>
    );
  }
  if (verified) {
    return (
      <Box color={theme.palette.primary.main} key="status_component">
        <Typography variant="subtitle2">Valid</Typography>
      </Box>
    );
  }

  return null;
};
